import { createContext } from 'react';
import { AdminUser } from '../types/AdminUser'

export const AdminUserContext = createContext<AdminUser>({
    uid: "",
    name: "",
    organizationId: ""
});